import {Box, Skeleton, SkeletonText} from '@chakra-ui/react';
import {FC} from 'react';

export const CategorySkeleton: FC = () => {
  return (
    <Box mx="10px">
      <Skeleton h={['81px', '100px']} w={['70px', '100px']} mb="12px" borderRadius="16px" />
      <SkeletonText skeletonHeight="20px" noOfLines={1} w="90%" />
    </Box>
  );
};
